import React, { FC, useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Navigation } from "swiper/modules";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { ReactComponent as ArrowIcon } from "src/assets/icons/arrow.svg";
import { SCREEN_BREAKPOINTS } from "src/constants/screenBreakpoints";
import { CardEmployee } from "./CardEmployee";
import { useGetTeamQuery } from "src/redux/api";
import { useMediaQuery } from "react-responsive";
import { getImageUrl } from "src/constants/urls";

const DEFAULT_QUOTE = "Вважаю, що лише креативні й талановиті люди можуть точно, вдало й ефективно виконувати свою роботу, саме такими є працівники нашої компанії";

export const Slider: FC = () => {
  const { data: teamMembers, isLoading } = useGetTeamQuery();
  const is2XLScreenBreakpoint = useMediaQuery({
    maxWidth: SCREEN_BREAKPOINTS["2XL"],
  });
  const isXLScreenBreakpoint = useMediaQuery({
    maxWidth: SCREEN_BREAKPOINTS.XL,
  });

  const isSMScreenBreakpoint = useMediaQuery({
    maxWidth: SCREEN_BREAKPOINTS.SM,
  });

  const getSlidesPerView = () => {
    if (isSMScreenBreakpoint) return 1;
    if (isXLScreenBreakpoint) return 2;
    if (is2XLScreenBreakpoint) return 3;

    return 4;
  };

  const employees = useMemo(() => {
    if (!teamMembers) return [];

    return teamMembers.map((member) => ({
      id: member.id,
      name: member.name,
      position: member.position,
      quote: member.quote && member.quote.trim() ? member.quote : DEFAULT_QUOTE,
      image: member.image ? getImageUrl(member.image) : null,
    }));
  }, [teamMembers]);

  if (isLoading) {
    return <div className="h-full flex items-center justify-center">Завантаження...</div>;
  }

  if (!employees.length) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 md:gap-4 h-full px-4 md:px-9 overflow-hidden">
      <Button
        className="our-team__button-prev"
        variant={ButtonVariants.OPACITY_GRAY}
      >
        <ArrowIcon className="w-3.5 sm:w-7 h-3.5 sm:h-7"/>
      </Button>

      <Swiper
        className="h-full"
        navigation={{
          nextEl: ".our-team__button-next",
          prevEl: ".our-team__button-prev",
        }}
        slidesPerView={getSlidesPerView()}
        spaceBetween={24}
        modules={[Navigation]}
      >
        {employees.map((employee) => (
          <SwiperSlide key={employee.id}>
            <CardEmployee {...employee} />
          </SwiperSlide>
        ))}
      </Swiper>

      <Button
        className="our-team__button-next"
        variant={ButtonVariants.OPACITY_GRAY}
      >
        <ArrowIcon className="w-3.5 sm:w-7 h-3.5 sm:h-7 rotate-180" />
      </Button>
    </div>
  );
};
